<template>
<div class="">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-12 py-5">
                <div class="foot-logo mb-4">
                    <router-link to="#"><img src="../assets/images/logo-white.png" alt="" class="img-fluid" /></router-link>
                </div>
                <ul class="list-inline footmenu">
                    <li class="list-inline-item"><router-link to="/" class="text-white">Home</router-link></li>
                    <li class="list-inline-item"><router-link to="/copyright" class="text-white">Copyright</router-link></li>
                    <li class="list-inline-item"><a href="http://fifmi.org" class="text-white" target="_blank">Global Location</a></li>
                    <li class="list-inline-item"><router-link to="https://fifmi.org.au:2096/" class="text-white" target="_blank">Webmail Login</router-link></li>
                    <li class="list-inline-item"><router-link to="/contact" class="text-white">Contact Us</router-link></li>
                    <li class="list-inline-item"><router-link to="/disclaimer" class="text-white">Disclaimer</router-link></li>
                    <li class="list-inline-item"><router-link to="/privacy-policy" class="text-white">Privacy Policy</router-link></li>
                    <li class="list-inline-item"><router-link to="/terms-of-use" class="text-white">Terms Of Use</router-link></li>
                </ul>
                <ul class="list-inline footaddress mb-0">
                    <li class="list-inline-item">
                        <i class="icofont-google-map"></i>
                        <span>5-7 Swettenham Rd, Minto NSW 2566, NSW</span>
                    </li>
                    <li class="list-inline-item">
                        <i class="icofont-phone"></i>
                        <span><router-link to="tel:+61 (2) 9603 3753" class="text-white">+61 (2) 9603 3753</router-link> , <a href="tel:+61 (2) 9603 3753" class="text-white">+61 (2) 9603 3753</a></span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="footer-botoom">
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-12">
                    <span class="copyright">© 2020 Forward In Faith International Ministries Australia, All rights reserved.</span>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>

export default {
    name: 'Footer',
}
</script>